import React, { useState } from 'react';
import { X } from 'lucide-react';
import { deletePublicacion, Publicacion } from '../../services/blogPublicaciones';

interface DeleteBlogPublicacionesProps {
    isOpen: boolean;
    publicacion: Publicacion | null;
    onClose: () => void;
    onSuccess: () => void;
}

const DeleteBlogPublicaciones: React.FC<DeleteBlogPublicacionesProps> = ({ isOpen, publicacion, onClose, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleDelete = async () => {
        if (!publicacion) return;
        setLoading(true);
        setError('');
        try {
            await deletePublicacion(publicacion.slug);
            onSuccess();
            onClose();
        } catch (err: any) {
            console.error(err);
            setError(err.response?.data?.message || 'Error al eliminar la publicación');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen || !publicacion) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
                <div className="flex justify-between items-center border-b px-6 py-4">
                    <h3 className="text-lg font-semibold text-gray-900">Eliminar Publicación</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <X className="w-5 h-5" />
                    </button>
                </div>
                <div className="px-6 py-4">
                    <p className="text-gray-700">
                        ¿Estás seguro de eliminar la publicación <strong>{publicacion.titulo}</strong>?
                        Esta acción no se puede deshacer.
                    </p>
                    {error && (
                        <div className="mt-3 bg-red-50 text-red-600 p-2 rounded-md text-sm">
                            {error}
                        </div>
                    )}
                </div>
                <div className="flex justify-end gap-3 border-t px-6 py-4">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        onClick={handleDelete}
                        disabled={loading}
                        className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50"
                    >
                        {loading ? 'Eliminando...' : 'Eliminar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteBlogPublicaciones;
